(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _BrokerList = _interopRequireDefault(require("../Components/BrokerList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var App = /*#__PURE__*/function (_React$Component) {
  function App() {
    _classCallCheck(this, App);
    return _callSuper(this, App, arguments);
  }
  _inherits(App, _React$Component);
  return _createClass(App, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_BrokerList["default"], {
        brokers: window.brokers,
        localization: window.localization,
        assetServer: window.assetServer
      });
    }
  }]);
}(React.Component);
var _default = exports["default"] = App;

},{"../Components/BrokerList":6}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var AccountType = function AccountType(props) {
  var txt = document.createElement('textarea');
  var name = function () {
    txt.innerHTML = props.name;
    return txt.value;
  }();
  var rate = function () {
    txt.innerHTML = props.rate;
    return txt.value;
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "account-type"
  }, /*#__PURE__*/React.createElement("div", {
    className: "account-type-name",
    dangerouslySetInnerHTML: {
      __html: name
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "payment-rate block-with-text",
    dangerouslySetInnerHTML: {
      __html: rate
    }
  }));
};
var _default = exports["default"] = AccountType;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _AccountType = _interopRequireDefault(require("./AccountType"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AccountTypeHiddenRow = function AccountTypeHiddenRow(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "inner-hidden-account-types"
  }, props.data.map(function (c) {
    return /*#__PURE__*/React.createElement(_AccountType["default"], {
      key: c.id,
      name: c.name,
      rate: c.rate
    });
  }));
};
var _default = exports["default"] = AccountTypeHiddenRow;

},{"./AccountType":2}],4:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _AccountType = _interopRequireDefault(require("./AccountType"));
var _AccountTypeHiddenRow = _interopRequireDefault(require("./AccountTypeHiddenRow"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var AccountTypeList = /*#__PURE__*/function (_React$Component) {
  function AccountTypeList(props) {
    var _this;
    _classCallCheck(this, AccountTypeList);
    _this = _callSuper(this, AccountTypeList, [props]);
    _this.state = {
      groupSize: 3,
      accounts: props.rebateaccounts
    };
    _this.breakArray = _this.breakArray.bind(_this);
    return _this;
  }

  /// Break the incoming array of RebateAccount Types into groups of 3
  /// each group represents a row in the display
  _inherits(AccountTypeList, _React$Component);
  return _createClass(AccountTypeList, [{
    key: "breakArray",
    value: function breakArray() {
      var arr = this.state.accounts;
      var groupSize = this.state.groupSize;
      var groups = arr.map(function (item, index) {
        return index % groupSize === 0 ? arr.slice(index, index + groupSize) : null;
      }).filter(function (item) {
        return item;
      });
      return groups;
    }
  }, {
    key: "render",
    value: function render() {
      var groups = this.breakArray();
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "broker-display-account-types"
      }, groups[0].map(function (c) {
        return /*#__PURE__*/React.createElement(_AccountType["default"], {
          key: c.id,
          name: c.name,
          rate: c.rate
        });
      })), /*#__PURE__*/React.createElement("div", {
        id: "hidden-payment-options_" + this.props.brokerId,
        className: "hidden-payment-options"
      }, function () {
        var rows = 0;
        groups.shift();
        return groups.map(function (c) {
          return /*#__PURE__*/React.createElement(_AccountTypeHiddenRow["default"], {
            key: ++rows,
            data: c
          });
        });
      }()));
    }
  }]);
}(React.Component);
var _default = exports["default"] = AccountTypeList;

},{"./AccountType":2,"./AccountTypeHiddenRow":3}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _RebateOption = _interopRequireDefault(require("./RebateOption"));
var _RatingIcon = _interopRequireDefault(require("./RatingIcon"));
var _AccountTypeList = _interopRequireDefault(require("./AccountTypeList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Broker = function Broker(props) {
  var nMore = props.localization.xMore.replace("{n}", '<span class="num-more">' + (props.numRebateAccountTypes - 3) + '</span>') + ' <span class="mdi mdi-chevron-down"></span>';
  var ratingBased = props.localization.userRatingBased.replace("{0}", props.numReviews);
  var sourceLink = props.localization.sourceLink.replace("{0}", "<a href=\"".concat(props.fxVerifyLink, "\" target=\"_blank\">fxverify.com > ").concat(props.code, "</a>"));
  var classForFeatured = "white-card broker-display-box";
  {
    (function () {
      if (props.isFeatured === "True" && !window.widgetView && window.firstBroker) {
        classForFeatured = "white-card broker-display-box is-featured-broker";
        window.updateFeatureCount(props.brokerId);
      }
      window.firstBroker = false;
    })();
  }
  return /*#__PURE__*/React.createElement("div", null, function () {
    if (props.supportedByCurrentCulture === "False" && (props.sortKey === "Index" || props.sortKey === "")) {
      return /*#__PURE__*/React.createElement("div", {
        className: "language-not-supported-cut-off"
      }, /*#__PURE__*/React.createElement("div", {
        "class": "or-wrap"
      }, /*#__PURE__*/React.createElement("div", {
        "class": "or"
      }, /*#__PURE__*/React.createElement("i", {
        "class": "fal fa-ban"
      }), " ", props.localization.notSupportedMessage), /*#__PURE__*/React.createElement("div", {
        "class": "strike-or"
      })));
    }
  }(), /*#__PURE__*/React.createElement("div", {
    className: classForFeatured
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "display-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "broker-display-image"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.link,
    className: "remoteTarget"
  }, function () {
    if (props.thumbnail === "") {
      return /*#__PURE__*/React.createElement("img", {
        src: props.assetServer + "/assets/images/brokers/file/placeholder.jpg",
        className: "broker-pic"
      });
    } else {
      return /*#__PURE__*/React.createElement("img", {
        src: props.assetServer + "/assets/images/brokers/file/" + props.thumbnail,
        className: "broker-pic"
      });
    }
  }()), /*#__PURE__*/React.createElement(_RatingIcon["default"], {
    key: props.id,
    overAllRating: props.overAllRating,
    popularityRating: props.popularityRating,
    pricingRating: props.pricingRating,
    regulatoryRating: props.regulatoryRating,
    userRating: props.userRating,
    sortKey: props.sortKey,
    brokerId: props.brokerId
  }))), /*#__PURE__*/React.createElement("div", {
    className: "broker-display-name"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.link,
    className: "remoteTarget"
  }, props.name), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "payment-options"
  }, /*#__PURE__*/React.createElement("a", {
    href: "javascript:void(0)",
    "data-toggle": "pop-pay-opt",
    "data-target-id": props.brokerId,
    "data-placement": "top",
    "data-trigger": "hover toggle",
    "data-html": "true"
  }, props.localization.paymentOption, " ", /*#__PURE__*/React.createElement("i", {
    className: "fal fa-info-circle"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "display-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "broker-display-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "broker-list-name-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "broker-list-name"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.link,
    className: "remoteTarget"
  }, props.name)), /*#__PURE__*/React.createElement("div", {
    className: "broker-list-divide"
  }, "\xBB"), /*#__PURE__*/React.createElement("div", {
    className: "broker-list-payment-options"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.link,
    className: "remoteTarget"
  }, props.localization.details))), /*#__PURE__*/React.createElement("div", {
    className: "border-line"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_AccountTypeList["default"], {
    rebateaccounts: props.rebateaccounts,
    brokerId: props.brokerId
  })), /*#__PURE__*/React.createElement("div", {
    className: "payment-options-more"
  }, function () {
    if (props.numRebateAccountTypes - 3 > 0) {
      return /*#__PURE__*/React.createElement("a", {
        href: "javascript:void(0)",
        onClick: function onClick() {
          $("#hidden-payment-options_" + props.brokerId).slideToggle({
            duration: 400,
            queue: false,
            progress: function progress(a, prog, ms) {
              window.ResizeFrame();
            }
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: nMore
        }
      }));
    }
  }())), /*#__PURE__*/React.createElement("div", {
    className: "display-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "payment-options"
  }, props.localization.paymentOption, /*#__PURE__*/React.createElement("div", {
    className: "border-line"
  })), /*#__PURE__*/React.createElement("div", {
    className: "broker-display-payment-options-list"
  }, props.rebateoptions.map(function (c) {
    return /*#__PURE__*/React.createElement(_RebateOption["default"], {
      key: c.id,
      option: c.option,
      description: c.description,
      overlay: "true",
      brokerId: props.brokerId,
      id: c.id
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "broker-display-payment-options-button"
  }, /*#__PURE__*/React.createElement("a", {
    href: props.setUpLink,
    id: "broker-setup-link-" + props.brokerId,
    className: "remoteTarget waves-effect"
  }, props.localization.getRebates)))), function () {
    if (props.supportedByCurrentCulture === "False") {
      return /*#__PURE__*/React.createElement("div", {
        className: "language-not-supported"
      }, /*#__PURE__*/React.createElement("a", {
        href: "javascript:void(0)",
        "data-toggle": "pop-supported-languages",
        "data-target-id": props.brokerId,
        "data-placement": "top",
        "data-trigger": "hover toggle"
      }, /*#__PURE__*/React.createElement("i", {
        "class": "fal fa-ban"
      }), " ", /*#__PURE__*/React.createElement("span", {
        className: "dashed"
      }, props.localization.notSupportedMessage)));
    }
  }()), /*#__PURE__*/React.createElement("div", {
    className: "hidden-rate",
    id: "hidden-rate-" + props.brokerId
  }, props.localization.overAllExplanation, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: props.overallRatingHtml
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden-rate",
    id: "hidden-pay-" + props.brokerId
  }, props.rebateoptions.map(function (c) {
    return /*#__PURE__*/React.createElement(_RebateOption["default"], {
      key: c.id,
      option: c.option,
      description: c.description,
      overlay: "false"
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden-rate",
    id: "hidden-supported-languages-" + props.brokerId
  }, props.supportedLanguages), /*#__PURE__*/React.createElement("div", {
    className: "hidden-rate",
    id: "hidden-overall-rate-" + props.brokerId
  }, props.localization.overAllExplanation, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: props.overallRatingHtml
    }
  })));
};
var _default = exports["default"] = Broker;

},{"./AccountTypeList":4,"./RatingIcon":7,"./RebateOption":8}],6:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Broker = _interopRequireDefault(require("./Broker"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BrokerList = /*#__PURE__*/function (_React$Component) {
  function BrokerList(props) {
    var _this;
    _classCallCheck(this, BrokerList);
    props.autoKill = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    if ($('#filtered-list-ids').length && $('#filtered-list-ids').val() !== "") {
      var stringToRemove = $('#filtered-list-ids').val();
      var toRemove = stringToRemove.split(',');
      var myArray = props.brokers.filter(function (el) {
        var found = toRemove.includes(el.id.toString());
        return found;
      });
      props.brokers = myArray;
    }
    _this = _callSuper(this, BrokerList, [props]);
    _this.state = {
      data: props.brokers,
      sortKey: '',
      filter: ''
    };
    _this.onSort = _this.onSort.bind(_this);
    return _this;
  }
  _inherits(BrokerList, _React$Component);
  return _createClass(BrokerList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      window.BrokerCompare.initPopovers(true);
    }
  }, {
    key: "onFilter",
    value: function onFilter(event) {
      this.setState({
        filter: event.target.value.substr(0, 20)
      });
    }
  }, {
    key: "onSort",
    value: function onSort(event) {
      var data = this.state.data;
      switch (event.target.value) {
        case 'Broker':
          data.sort(function (a, b) {
            return a['name'].localeCompare(b['name']);
          });
          this.setState({
            data: data,
            sortKey: event.target.value
          });
          break;
        case 'Popularity':
          data.sort(function (a, b) {
            if (parseFloat(a.PopularityRating_Sort) > parseFloat(b.PopularityRating_Sort)) {
              //console.log(parseFloat(a.PopularityRating_Sort) + " is greater than " + parseFloat(b.PopularityRating_Sort));
              return -1;
            }
            ;
            if (parseFloat(a.PopularityRating_Sort) < parseFloat(b.PopularityRating_Sort)) {
              //console.log(parseFloat(a.PopularityRating_Sort) + " is less than " + parseFloat(b.PopularityRating_Sort));
              return 1;
            }
            ;

            //console.log(parseFloat(a.PopularityRating_Sort) + " is equal " + parseFloat(b.PopularityRating_Sort));

            if (parseInt(a.numReviews, 10) > parseInt(b.numReviews, 10)) {
              return -1;
            }
            ;
            if (parseInt(a.numReviews, 10) < parseInt(b.numReviews, 10)) {
              return 1;
            }
            ;
          });
          this.setState({
            data: data,
            sortKey: event.target.value
          });
          break;
        case 'UserRating':
          data.sort(function (a, b) {
            if (a.UserRating_Sort > b.UserRating_Sort) {
              return -1;
            }
            ;
            if (a.UserRating_Sort < b.UserRating_Sort) {
              return 1;
            }
            ;
            if (parseInt(a.numReviews, 10) > parseInt(b.numReviews, 10)) {
              return -1;
            }
            ;
            if (parseInt(a.numReviews, 10) < parseInt(b.numReviews, 10)) {
              return 1;
            }
            ;
          });
          this.setState({
            data: data,
            sortKey: event.target.value
          });
          break;
        case 'Pricing':
          data.sort(function (a, b) {
            if (a.PricingRating_Sort > b.PricingRating_Sort) {
              return -1;
            }
            ;
            if (a.PricingRating_Sort < b.PricingRating_Sort) {
              return 1;
            }
            ;
            if (parseInt(a.numReviews, 10) > parseInt(b.numReviews, 10)) {
              return -1;
            }
            ;
            if (parseInt(a.numReviews, 10) < parseInt(b.numReviews, 10)) {
              return 1;
            }
            ;
          });
          this.setState({
            data: data,
            sortKey: event.target.value
          });
          break;
        case 'RegulationRating':
          data.sort(function (a, b) {
            if (a.RegulatoryRating_Sort > b.RegulatoryRating_Sort) {
              return -1;
            }
            ;
            if (a.RegulatoryRating_Sort < b.RegulatoryRating_Sort) {
              return 1;
            }
            ;
            if (parseInt(a.numReviews, 10) > parseInt(b.numReviews, 10)) {
              return -1;
            }
            ;
            if (parseInt(a.numReviews, 10) < parseInt(b.numReviews, 10)) {
              return 1;
            }
            ;
          });
          this.setState({
            data: data,
            sortKey: event.target.value
          });
          break;
        case 'Overall':
          data.sort(function (a, b) {
            if (a.OverallRating_Sort > b.OverallRating_Sort) {
              return -1;
            }
            ;
            if (a.OverallRating_Sort < b.OverallRating_Sort) {
              return 1;
            }
            ;
            if (parseInt(a.numReviews, 10) > parseInt(b.numReviews, 10)) {
              return -1;
            }
            ;
            if (parseInt(a.numReviews, 10) < parseInt(b.numReviews, 10)) {
              return 1;
            }
            ;
          });
          this.setState({
            data: data,
            sortKey: event.target.value
          });
          break;
        default:
          data.sort(function (a, b) {
            return a.index - b.index;
          });
          this.setState({
            data: data,
            sortKey: event.target.value
          });
          break;
      }
      ;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var filteredBrokers = this.props.brokers.filter(function (broker) {
        return broker.name.toLowerCase().indexOf(_this2.state.filter.toLowerCase()) !== -1;
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        value: "prayer"
      }), /*#__PURE__*/React.createElement("div", {
        "class": "broker-rebates-list-subtext font-13",
        dangerouslySetInnerHTML: {
          __html: this.props.localization.howItWorks
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 15 + 'px'
        },
        id: "search-bar"
      }, /*#__PURE__*/React.createElement("div", {
        id: "search-input"
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-container"
      }, /*#__PURE__*/React.createElement("input", {
        placeholder: this.props.localization.search,
        onChange: this.onFilter.bind(this),
        className: "frn-override",
        id: "broker-search-input",
        name: "criteria",
        type: "search",
        autocomplete: this.props.autoKill
      }))), /*#__PURE__*/React.createElement("div", {
        id: "search-filter-menu"
      }, /*#__PURE__*/React.createElement("span", {
        className: "sort-text"
      }, this.props.localization.sort, ":"), /*#__PURE__*/React.createElement("div", {
        id: "select-cover",
        className: "slate"
      }, /*#__PURE__*/React.createElement("select", {
        name: "ddlSortBy",
        id: "ddlSortBy",
        onChange: function onChange(e) {
          return _this2.onSort(e);
        },
        className: "frn-override browser-default"
      }, /*#__PURE__*/React.createElement("option", {
        className: "camelcase",
        value: "Index",
        id: "sort-option"
      }, this.props.localization.sort), /*#__PURE__*/React.createElement("option", {
        className: "camelcase",
        value: "Overall"
      }, this.props.localization.overallScore), /*#__PURE__*/React.createElement("option", {
        className: "camelcase",
        value: "Broker"
      }, this.props.localization.name), /*#__PURE__*/React.createElement("option", {
        className: "camelcase",
        value: "UserRating"
      }, this.props.localization.userRating), /*#__PURE__*/React.createElement("option", {
        className: "camelcase",
        value: "Pricing"
      }, this.props.localization.pricingRating), /*#__PURE__*/React.createElement("option", {
        className: "camelcase",
        value: "RegulationRating"
      }, this.props.localization.regulatorRating), /*#__PURE__*/React.createElement("option", {
        className: "camelcase",
        value: "Popularity"
      }, this.props.localization.popularity)), /*#__PURE__*/React.createElement("input", {
        id: "hdnRatingType",
        name: "hdnRatingType",
        value: "Overall",
        type: "hidden"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "font-13 round-turn-msg"
      }, "*", this.props.localization.paidPerClosedPosition), filteredBrokers.map(function (c) {
        return /*#__PURE__*/React.createElement(_Broker["default"], {
          key: c.id,
          index: c.index,
          brokerId: c.id,
          isFeatured: c.isFeatured,
          name: c.name,
          thumbnail: c.thumbnail,
          rebateoptions: c.rebateoptions,
          supportedByCurrentCulture: c.supportedByCurrentCulture,
          supportedLanguages: c.supportedLanguages,
          paymentOptionStr: _this2.props.paymentOptionsStr,
          numRebateAccountTypes: c.numRebateAccountTypes,
          overAllRating: c.OverallRating,
          popularityRating: c.PopularityRating,
          pricingRating: c.PricingRating,
          regulatoryRating: c.RegulatoryRating,
          userRating: c.UserRating,
          sortKey: _this2.state.sortKey,
          rebateaccounts: c.RebateAccounts,
          ratingtype: c.RatingType,
          numReviews: c.numReviews,
          fxVerifyLink: c.fxVerifyLink,
          code: c.code,
          slug: c.UrlSlug,
          link: c.link,
          localization: _this2.props.localization,
          setUpLink: c.setUpLink,
          overallRatingHtml: c.overallRatingHtml,
          assetServer: _this2.props.assetServer
        });
      })));
    }
  }]);
}(React.Component);
var _default = exports["default"] = BrokerList;

},{"./Broker":5}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var RatingIcon = function RatingIcon(props) {
  var star = /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-star"
  });
  var heart = /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-heart"
  });
  var classNames = ["broker-rating"];
  if (props.sortKey !== 'UserRating') {
    classNames.push('overall');
  } else {
    classNames.push('user');
  }
  return /*#__PURE__*/React.createElement("div", null, function () {
    if (props.sortKey !== 'UserRating') {
      return star;
    } else {
      return heart;
    }
  }(), /*#__PURE__*/React.createElement("span", {
    className: classNames.join(' ')
  }, /*#__PURE__*/React.createElement("a", {
    href: "javascript:void(0)",
    "data-toggle": props.sortKey === 'UserRating' ? "pop-rate" : "pop-overall-rate",
    "data-target-id": props.brokerId,
    "data-placement": "top",
    "data-trigger": "hover toggle",
    "data-html": "true"
  }, function () {
    if (props.sortKey === 'UserRating') {
      return props.userRating;
    } else {
      return props.overAllRating;
    }
  }())));
};
var _default = exports["default"] = RatingIcon;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var RebateOption = function RebateOption(props) {
  var description = /*#__PURE__*/React.createElement("div", {
    className: "hidden-rate",
    id: "hidden-description-" + props.brokerId + "-" + props.id,
    dangerouslySetInnerHTML: {
      __html: props.description
    }
  });
  var withoutPop = /*#__PURE__*/React.createElement("div", {
    className: "broker-display-payment-options-list-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-icon"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "fa-icon fa-icon-16 fa-w-16 grn-check"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "/content/dist/fonts/fa-sprites.svg#check-circle-regular"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "list-text"
  }, props.option));
  var withPop = /*#__PURE__*/React.createElement("a", {
    className: "broker-display-payment-options-list-item",
    href: "javascript:void(0)",
    "data-toggle": "pop-rebate-description",
    "data-target-id": props.brokerId + "-" + props.id,
    "data-placement": "top",
    "data-trigger": "hover toggle",
    "data-html": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-icon"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "fa-icon fa-icon-16 fa-w-16 grn-check"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "/content/dist/fonts/fa-sprites.svg#check-circle-regular"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "list-text"
  }, /*#__PURE__*/React.createElement("span", {
    className: "crashed",
    dangerouslySetInnerHTML: {
      __html: props.option
    }
  })));
  return /*#__PURE__*/React.createElement("div", null, function () {
    if (props.overlay !== 'false') {
      return withPop;
    } else {
      return withoutPop;
    }
  }(), function () {
    if (props.overlay !== 'false') {
      return description;
    }
    return "";
  }());
};
var _default = exports["default"] = RebateOption;

},{}],9:[function(require,module,exports){
"use strict";

var _App = _interopRequireDefault(require("./Classes/App.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var domContainer = document.querySelector('#BrokerList');
ReactDOM.render(React.createElement(_App["default"]), domContainer);

},{"./Classes/App.js":1}]},{},[9]);
